import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filterExams',
    standalone: false
})
export class FilterExamsPipe implements PipeTransform {

  transform(examTypes: any[], hmo: string, HMOName: string, hideCoded: boolean = false): any[] {
    if (!examTypes || !hmo) return [];

    const codeKey = (hmo === 'Private' ? 'Private' : HMOName) + 'HasCode';

    return examTypes.filter(exam => {
        let allowed = false;
        if (hmo === 'Private') {
            allowed = exam['Private'] === true;
        } else if (hmo === 'Hmo' && HMOName) {
            allowed = exam[HMOName] === true;
        }
        if (!allowed) return false;
        // When the patient has no code, hide exams that require a code for this HMO.
        if (hideCoded && exam[codeKey]) return false;
        return true;
    });
}
}
